export default __webpack_public_path__ + "static/18691-96f6fbb77135c30a60de8d10783d29ac.jpg";